import type { ObjectId } from '@racemap/sdk/schema/base';
import { Tag } from 'antd';
import { useMonitorActions, useSelectedStarterId } from 'src/store/monitor_beta/monitorStore';

export const AlertLocationTag = ({
  location,
  starterId,
}: {
  location?: { lat?: number; lng?: number };
  starterId: ObjectId | string | undefined | null;
}) => {
  const selectedStarterId = useSelectedStarterId();
  const { flyTo, setSelectedStarterId } = useMonitorActions();

  const handleClick = async () => {
    if (location && (location.lat != null || location.lng != null)) {
      flyTo({
        center: [location.lng ?? 0, location.lat ?? 0],
        zoom: 14,
      });
    }
    if (starterId != null && starterId !== selectedStarterId) {
      await setSelectedStarterId(starterId.toString(), false);
    }
  };

  return (
    <Tag onClick={handleClick} style={{ cursor: 'pointer' }}>
      {location && (location.lat != null || location.lng != null) ? (
        <div>
          {location.lat != null && `Lat: ${location.lat.toFixed(5)}`}
          {location.lat != null && location.lng != null && ', '}
          {location.lng != null && `Lng: ${location.lng.toFixed(5)}`}
        </div>
      ) : (
        'Location not available'
      )}
    </Tag>
  );
};
